import { createSelector } from '@ngrx/store';

export const selectDashboardState = state => state.dashboard;

export const getSingleBuildingId = createSelector(
	selectDashboardState,
	dashboard => dashboard.singleBuildingId
);

export const isDashboardDetailViewEnabled = createSelector(
	selectDashboardState,
	dashboard => dashboard.detailedView
);

export const detailedItemName = createSelector(
	selectDashboardState,
	dashboard => dashboard.detailedItemName
);

export const isMobileFilterOpened = createSelector(
	selectDashboardState,
	dashboard => dashboard.buildingMobileFilterOpened
);

export const isDesktopFilterOpened = createSelector(
	selectDashboardState,
	dashboard => dashboard.buildingDesktopFilterOpened
);

export const isSortOpened = createSelector(
	selectDashboardState,
	dashboard => dashboard.buildingSortOpened
);

export const getBuildingsListFiltersState = createSelector(
	selectDashboardState,
	dashboard => dashboard.buildingListFilterState
);

export const getTenantsListFiltersState = createSelector(
	selectDashboardState,
	dashboard => dashboard.tenantsListFilterState
);

export const getZonesListFiltersState = createSelector(
	selectDashboardState,
	dashboard => dashboard.zonesListFilterState
);

export const getComfortFiltersState = createSelector(
	selectDashboardState,
	dashboard => dashboard.comfortFilterState
);

export const getTechStatusFiltersState = createSelector(
	selectDashboardState,
	dashboard => dashboard.techStatusFilterState
);

export const getTotalKpiEnergyOpenState = createSelector(
	selectDashboardState,
	dashboard => dashboard.totalKpiState.energy.opened
);

export const getTotalKpiComfortOpenState = createSelector(
	selectDashboardState,
	dashboard => dashboard.totalKpiState.comfort.opened
);

export const getTotalKpiTechStatusOpenState = createSelector(
	selectDashboardState,
	dashboard => dashboard.totalKpiState.techStatus.opened
);

export const isTotalKpiCardOpened = createSelector(selectDashboardState, dashboard => {
	const kpiState = dashboard.totalKpiState;

	return kpiState.energy.opened || kpiState.comfort.opened || kpiState.techStatus.opened;
});

export const getTotalKpiState = createSelector(
	selectDashboardState,
	dashboard => dashboard.totalKpiState
);
